/**
 * Autogenerated file don't modify
 */
(function () {
(function (swiper) {
    'use strict';

    var moyaFetch = MoyaContainer.get('core.fetch');
    MoyaComponents.register('sitemap.custom-menu', [
        'https://cdnjs.cloudflare.com/ajax/libs/Swiper/9.4.1/swiper-bundle.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/Swiper/9.4.1/swiper-bundle.css',
    ], function (el) {
        var customMenu = new CustomMenu(el);
        customMenu.run();
    });
    var CustomMenu = /** @class */ (function () {
        function CustomMenu(el) {
            this.el = el;
        }
        CustomMenu.prototype.run = function () {
            this.initSwiper();
            this.bindButtons();
        };
        CustomMenu.prototype.initSwiper = function () {
            var swiperParams = {
                direction: 'horizontal',
                slidesPerView: 'auto',
                spaceBetween: 30,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    768: {
                        spaceBetween: 70,
                    },
                },
            };
            new swiper.Swiper('#' + this.el.id, swiperParams);
        };
        CustomMenu.prototype.bindButtons = function () {
            var _this = this;
            var linkButtons = this.el.querySelectorAll('a.menu-link');
            linkButtons.forEach(function (button) {
                button.addEventListener('click', function (ev) {
                    document.querySelector('#main > .box').classList.add('loadingContent');
                    ev.preventDefault();
                    _this.removeCurrent(linkButtons);
                    button.classList.add('isCurrent');
                    moyaFetch.fetchHtml(button.href).then(function (docRes) {
                        document.querySelector('#main > .box > .boxText').innerHTML = docRes.querySelector('#main > .box > .boxText').innerHTML;
                    }).then(function () {
                        setTimeout(function () {
                            document.querySelector('#main > .box').classList.remove('loadingContent');
                        }, 800);
                    });
                });
            });
        };
        CustomMenu.prototype.removeCurrent = function (linkButtons) {
            linkButtons.forEach(function (button) {
                button.classList.remove('isCurrent');
            });
        };
        return CustomMenu;
    }());

}(window));
typeof tsBuild === 'function' && tsBuild();})();
